// Membership roles that sit outside the company (memberships.EXTERNAL_ROLES).
// A borrower and a realtor each have a portal; a deal-thread party (title or
// escrow) has only the deals they were added to.
export const EXTERNAL_ROLES = ['borrower', 'realtor', 'party'];

export const isExternalRole = (role) => EXTERNAL_ROLES.includes(role);

// Where an external seat lands after sign-in. Staff get `fallback`.
export const homeForRole = (role, fallback = '/portal') => {
  if (role === 'borrower') return '/borrower';
  if (role === 'realtor') return '/realtor';
  if (role === 'party') return '/party';
  return fallback;
};
